import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type {
    CommandContribution,
    CommandRegistry,
} from '@patsnap/tahiti-core';
import type {
    LoginDialogOptions,
    LoginDialogResult,
} from '../components/LoginDialog.vue';
import { LoginDialogService } from './login-dialog-service';
import type { RegisterMethod } from '../utils';

// Re-export types for external use
export type { LoginDialogOptions, LoginDialogResult };

/**
 * 打开登录对话框的参数
 */
export interface OpenLoginDialogPayload {
    /** 登录页面 URL */
    loginUrl?: string;
    /** 触发来源 */
    trigger_source?: string;
    /** 是否禁止关闭登录弹窗 */
    withoutClose?: boolean;
    /** 游客注册墙：用户点击注册按钮时的回调，用于埋点 */
    onClickRegister?: (method: RegisterMethod) => void;
}

/**
 * Login 对话框命令处理器
 */
@injectable()
export class LoginDialogCommandHandler implements CommandContribution {
    constructor(
        @inject(LoginDialogService) private _dialogService: LoginDialogService,
    ) {}

    /**
     * 处理打开登录对话框命令
     */
    private async _handleOpenLoginDialog(payload?: OpenLoginDialogPayload): Promise<LoginDialogResult> {
        return this._dialogService.open({
            loginUrl: payload?.loginUrl,
            trigger_source: payload?.trigger_source,
            withoutClose: payload?.withoutClose,
            onClickRegister: payload?.onClickRegister,
        });
    }

    /**
     * 注册命令
     */
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: 'login:open-dialog',
        }, {
            execute: (payload?: OpenLoginDialogPayload) => {
                return this._handleOpenLoginDialog(payload);
            },
        });
    }
}

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开登录对话框
         * @param commandId - 命令 ID
         * @param params - 参数
         */
        executeCommand(commandId: 'login:open-dialog', params?: OpenLoginDialogPayload): Promise<LoginDialogResult>;
    }
}
